import {
  BillingCatalog,
  PageResponse,
  Subscription,
  SubscriptionListItem,
  SubscriptionListQuery,
} from '../../types/subscription.ts';
import { SubscriptionState } from '../reducers/subscription.reducer.ts';
import { RootState } from '../store.ts';

const getSubscriptionState = (state: RootState): SubscriptionState => state.subscription;
export const getSubscription = (state: RootState): Subscription | undefined => getSubscriptionState(state).subscription;
export const getIsLoadingSubscription = (state: RootState): boolean =>
  getSubscriptionState(state).isLoadingSubscription;

export const getSubscriptionError = (state: RootState): string => getSubscriptionState(state).subscriptionError;

export const getAllSubscriptions = (state: RootState): PageResponse<SubscriptionListItem> | undefined =>
  getSubscriptionState(state).allSubscriptions;
export const getAllSubscriptionsQuery = (state: RootState): SubscriptionListQuery =>
  getSubscriptionState(state).allSubscriptionsQuery;
export const getIsLoadingAllSubscriptions = (state: RootState): boolean =>
  getSubscriptionState(state).isLoadingAllSubscriptions;
export const getIsAssigningSubscription = (state: RootState): boolean =>
  getSubscriptionState(state).isAssigningSubscription;
export const getAssignSubscriptionSuccess = (state: RootState): boolean =>
  getSubscriptionState(state).assignSubscriptionSuccess;
export const getIsCancellingSubscription = (state: RootState): boolean =>
  getSubscriptionState(state).isCancellingSubscription;
export const getCancelSubscriptionSuccess = (state: RootState): boolean =>
  getSubscriptionState(state).cancelSubscriptionSuccess;

export const getBillingCatalog = (state: RootState): BillingCatalog | undefined =>
  getSubscriptionState(state).billingCatalog;
export const getIsOpeningPaymentPage = (state: RootState): boolean => getSubscriptionState(state).isOpeningPaymentPage;
export const getIsSwitchingToFree = (state: RootState): boolean => getSubscriptionState(state).isSwitchingToFree;
